<cm-inspector-section>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'name'" [label]="'Name'"></cm-value-slot>
        <cm-value-slot
            [node]="$node()"
            [overwrittenValue]="$parameters().parameters.type"
            (updatedOverwrittenValue)="changeType($event)"
            [key]="'parameters'"
            [subKey]="['type']"
            [label]="'Type'"
            [selectionPossibilities]="typeSelectionPossibilities"
        ></cm-value-slot>

        @if ($parameters().parameters.type === "MattressComputedCurveSwapReferenceFrame") {
            <cm-value-slot
                [node]="$node()"
                [key]="'parameters'"
                [subKey]="['curve']"
                [label]="'Curve'"
                [selectionPossibilities]="$curveSelectionPossibilities()"
            ></cm-value-slot>
            <cm-value-slot
                [node]="$node()"
                [key]="'parameters'"
                [subKey]="['oldReferenceFrame']"
                [label]="'Old Reference Frame'"
                [selectionPossibilities]="$oldReferenceFrameSelectionPossibilities()"
            ></cm-value-slot>
            <cm-value-slot
                [node]="$node()"
                [key]="'parameters'"
                [subKey]="['newReferenceFrame']"
                [label]="'New Reference Frame'"
                [selectionPossibilities]="$newReferenceFrameSelectionPossibilities()"
            ></cm-value-slot>
        }
    </ng-container>
</cm-inspector-section>
